import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'zeroToEmpty'
})
export class ZeroToEmptyPipe implements PipeTransform {
	transform(value: number | string): string | number {
		return value == 0 || value == '0' ? '' : value;
	}
}
